import { IsiIWSAssociatedViewContext } from "./../GridView/AssociatedView/IsiIwsAssociatedViewContext";
import { IIsiDtoMenuObject } from "./../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";

export class IsiActionContext {

    private _uiAction: IIsiDtoIwsUIAction;
    private _event: Event;
    private _menu: IIsiDtoMenuObject;
    private _menuId: string;
    private _associatedViewContext: IsiIWSAssociatedViewContext;
    private _beforeActionOnDetail = true;
    private _afterChooseInstance = true;

    constructor(uiAction?: IIsiDtoIwsUIAction) {
        this._uiAction = uiAction;
    }

    get uiAction() {
        return this._uiAction;
    }

    set uiAction(value) {
        this._uiAction = value;
    }

    get menu() {
        return this._menu;
    }

    set menu(value) {
        this._menu = value;
    }

    get menuId() {
        return this._menuId;
    }

    set menuId(value) {
        this._menuId = value;
    }

    get event() {
        return this._event;
    }

    set event(value) {
        this._event = value;
    }

    get associatedViewContext() {
        return this._associatedViewContext;
    }

    set associatedViewContext(value) {
        this._associatedViewContext = value;
    }

    get beforeActionOnDetail() {
        return this._beforeActionOnDetail;
    }

    set beforeActionOnDetail(value) {
        this._beforeActionOnDetail = value;
    }

    get afterChooseInstance() {
        return this._afterChooseInstance;
    }

    set afterChooseInstance(value) {
        this._afterChooseInstance = value;
    }
    isAssociatedViewAction(): boolean {
        if (this._associatedViewContext) {
            return true;
        } else {
            return false;
        }
    }
    isFormAction(): boolean {
        return !this.isAssociatedViewAction();
    }
}
